import {
  FlowOperationType,
  FlowTemplate,
  PopulatedFlow,
} from '@activepieces/shared';
import { useMutation } from '@tanstack/react-query';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { t } from 'i18next';

import { showErrorToast } from '@/components/ui/use-toast';
import { folderIdParamName } from '@/features/folders/component/folder-filter-list';
import { foldersApi } from '@/features/folders/lib/folders-api';
import { authenticationSession } from '@/lib/authentication-session';

import { flowsApi } from '../lib/flows-api';

export const useCreateFlowFromTemplate = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  return useMutation<PopulatedFlow, Error, FlowTemplate>({
    mutationFn: async ({ name, template: flowTemplate }: FlowTemplate) => {
      const folderId = searchParams.get(folderIdParamName);
      const folder =
        folderId && folderId !== 'NULL'
          ? await foldersApi.get(folderId)
          : undefined;

      const newFlow = await flowsApi.create({
        displayName: t(name),
        projectId: authenticationSession.getProjectId()!,
        folderName: folder?.displayName,
      });

      return await flowsApi.update(newFlow.id, {
        type: FlowOperationType.IMPORT_FLOW,
        request: {
          displayName: t(name),
          triggers: flowTemplate.triggers,
          actions: flowTemplate.actions,
          connections: flowTemplate.connections,
          schemaVersion: flowTemplate.schemaVersion,
        },
      });
    },
    onSuccess: (flow) => {
      navigate(`/flows/${flow.id}`);
    },
    onError: (error) => {
      showErrorToast(error);
    },
  });
};
